import {
  File01Icon,
  Analytics01Icon,
  BookOpen01Icon,
  Target01Icon,
  DiscordIcon,
} from "@hugeicons/core-free-icons";

/** Shared offer content for the paywall modal and the public pricing page. */

export function getPassBenefits(boardShortName: string) {
  return [
    { icon: File01Icon, title: "Every past paper, timed like the real exam", desc: "Full papers under real conditions." },
    { icon: BookOpen01Icon, title: "A worked solution for every question", desc: `The full method, for the whole ${boardShortName} bank.` },
    { icon: Target01Icon, title: "Adaptive practice on your weak topics", desc: "Drills tuned to what you keep getting wrong." },
    { icon: Analytics01Icon, title: "Your predicted score, tracked", desc: "See where you'd land and watch it climb." },
    { icon: DiscordIcon, title: "Private Discord with top-uni mentors", desc: "Ask mentors from top universities, any time." },
  ];
}

/** Real platform figures, supplied by the team. Keep in sync as they grow. */
export const PASS_STATS = [
  { value: "1,800+", label: "students" },
  { value: "2.5k+", label: "questions" },
  { value: "250+", label: "into Cambridge last year" },
];

export interface PassPlan {
  /** Stable UI key — selection state survives the price flag loading. */
  id: string;
  /** The Autumn plan actually attached at checkout. */
  checkoutId: string;
  name: string;
  amount: number;
  /** Pre-sale price, struck through next to `amount` when set. */
  originalAmount?: number;
  /** Small label next to the name, e.g. "Most popular". */
  tag?: string;
  cadence: string;
  note: string;
  /** Full-width anchor line at the bottom of the card, e.g. the weekly comparison. */
  valueNote?: string;
}

/** Eyebrow shown above the plan chooser while the sale runs. */
export const SALE_LABEL = "Back to school sale";

/**
 * Back to school sale, everyone sees it (the Aug 2026 geo price test was
 * scrapped on 2 Sep 2026 before it resolved). Strikethrough prices are the
 * pre-sale list prices; the sale plans live in Autumn alongside them.
 */
export function getPassPlans(): PassPlan[] {
  return [
    {
      id: "pass_lifetime",
      checkoutId: "pass_lifetime_9499",
      name: "Lifetime",
      amount: 94.99,
      originalAmount: 150,
      tag: "Best value",
      cadence: "one payment",
      note: "Yours through exam day and beyond.",
      valueNote: "Cheaper than 5 weeks of Weekly",
    },
    {
      id: "pass_weekly",
      checkoutId: "pass_weekly_20",
      name: "Weekly",
      amount: 20,
      originalAmount: 25,
      cadence: "per week",
      note: "Cancel anytime.",
    },
  ];
}

/** Pence only when a discount leaves them: £150, £112.50. */
export function formatPrice(amount: number) {
  return `£${Number.isInteger(amount) ? amount : amount.toFixed(2)}`;
}

/** What a scholarship holder actually pays, mirroring the Autumn reward. */
export function priceAfterAward(amount: number, awardPercent?: number | null) {
  if (!awardPercent) return amount;
  return Math.round(amount * (100 - awardPercent)) / 100;
}
